import React, { useEffect, useState } from "react";
import {
  AppBar,
  Button,
  createStyles,
  Divider,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  makeStyles,
  Radio,
  RadioGroup,
  TextField,
  Theme,
  Typography,
} from "@material-ui/core";
import Icon from "@mdi/react";
import { useForm } from "react-hook-form";
import { Autocomplete } from "@material-ui/lab";
import JalaliUtils from "@date-io/jalaali";
import { useMutation, useQuery } from "react-query";
import MotorPlate from "../components/motorPlate";
import Plate from "../components/plate";
import { getTPLs } from "../requests/getTPLs";
import { mdiClose, mdiHome } from "@mdi/js";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { convertPersianDigit2English } from "../../../utils/helpers";
import axios from "axios";

import getVehicleByPlateNum from "../requests/getVehicleByPlateNum";
//Styles
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fixedModal: {},
    inlineRadioGroups: {
      display: "flex",
      flexDirection: "row",
    },
    drawDown: {
      padding: "20px 12px",
      backgroundColor: "#fff",
      marginBottom: "50px",
    },
    circularIcon: {
      color: "#2f4858",
      paddingLeft: "8px",
      position: "fixed",
      bottom: 0,
      opacity: "90%",
    },
    textInput: {
      // width: '25ch',
      "& input, .MuiSelect-root": {
        padding: "6px 0 12px !important",
      },

      "& .MuiInput-underline::before": {
        borderBottom: "1px solid #d8d8d8 !important",
      },
    },
    errorText: {
      color: "#F30000",
      fontSize: "11px",
    },
    errorPlate: {
      marginTop: "20px",
      marginLeft: "15px",
    },
    topText: {
      color: "#2f4858",
      fontSize: "16px",
    },
    appBar: {
      padding: "8px 16px",
      backgroundColor: "#ffffff",
      zIndex: theme.zIndex.drawer + 1,
      boxShadow:
        "0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.2)",
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    bottom: {
      position: "fixed",
      bottom: 0,
      left: 0,
      width: "100%",
      height: "80px",
      backgroundColor: "#fff",
      borderTop: "0.5px solid #828282",
      padding: "16px",
      zIndex: 100,
    },
  })
);

export const FilterForm = (props: {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
}) => {
  const classes = useStyles();
  const { register, handleSubmit, getValues, errors, setValue } = useForm({
    defaultValues: {
      driverName: null,
    },
  });

  const [entityType, setEntityType] = useState("order");
  const [vehicleType, setVehicleType] = useState("CAR");
  const [platePattern, setPlatePattern] = useState<any>("");
  const [courier, setCourier] = useState<any>(null);
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);

  let filterParams;

  useEffect(() => {
    setPlatePattern(/^\d{2}[\u0600-\u06FF]\d{3}\-\d{2}$/g);
    if (vehicleType === "MOTORCYCLE") {
      setPlatePattern(/^\d{8}$/g);
    }
  }, [vehicleType]);

  const onSubmit = (data: any) => {
    let fetchedPlateVehicleId;

    if (data.plateNumber) {
      getVehicleByPlateNum(data.plateNumber).then(
        (fetchedData: any) => {
          if (fetchedData.data.length > 0) {
            fetchedPlateVehicleId = fetchedData.data[0].id;

            filterParams = {
              "fleetId.equals": courier,
              "driverName.contains": data.driverName,
              "vehicleId.equals": fetchedPlateVehicleId,
              "created.greaterThan": startDate,
              "created.lessThan": endDate,
              "pageNumber": "1",
              "size": "50",
              "sort": "id,desc",
            };

            props.onSubmit(filterParams); //This probably ends up in prop drilling
            // console.log(filterParams['created.greaterThan']);
          } else {
            props.onClose();
          }
        },
      );
    } else {
      filterParams = {
        "fleetId.equals": courier,
        "driverName.contains": data.driverName,
        "created.greaterThan": startDate,
        "created.lessThan": endDate,
        "pageNumber": "1",
        "size": "50",
        "sort": "id,desc",
      };
      props.onSubmit(filterParams);
    }
  };

  const handleEntityRadioChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setEntityType((event.target as HTMLInputElement).value);
  };

  const handleVehicleRadioChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setVehicleType((event.target as HTMLInputElement).value);
  };

  const jumpFocusOn = (itemID: string): void => {
    const focusableElem: HTMLElement | null = document.getElementById(itemID);
    focusableElem?.focus();
  };

  const {
    isLoading,
    error,
    data: TPLs,
  } = useQuery("TPLs", getTPLs, {
    staleTime: 5 * 60 * 1000, //30 seconds fresh data
    cacheTime: 30 * 60 * 1000, //3 minutes fresh
  });

  const values = getValues();

  return (
    <div className={classes.fixedModal}>
      <div
        className={classes.drawDown}
        style={{ visibility: props.open ? "visible" : "hidden" }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={3}>
            <Grid item>
              <FormLabel component="legend">نوع</FormLabel>
              <RadioGroup
                row
                name="entity-type"
                value={entityType}
                onChange={handleEntityRadioChange}
              >
                <FormControlLabel
                  value="parcel"
                  control={<Radio />}
                  label="محموله"
                />
                <FormControlLabel
                  value="order"
                  control={<Radio />}
                  label="سفارش"
                />
              </RadioGroup>
            </Grid>
            <Divider />
            <Grid item>
              <FormLabel component="legend">وسیله نقلیه</FormLabel>
              <RadioGroup
                row
                name="vehicle-type"
                value={vehicleType}
                onChange={handleVehicleRadioChange}
              >
                <FormControlLabel
                  value="CAR"
                  control={<Radio />}
                  label="سواری"
                />
                <FormControlLabel
                  value="PICKUPS"
                  control={<Radio />}
                  label="وانت"
                />

                <FormControlLabel
                  value="MOTORCYCLE"
                  control={<Radio />}
                  label="موتور سیکلت"
                />
              </RadioGroup>
            </Grid>
            <Grid item xs={12}>
              {vehicleType === "MOTORCYCLE"
                ? (
                  <MotorPlate
                    getNumber={(number) => setValue("plateNumber", number)}
                  />
                )
                : (
                  <Plate
                    getNumber={(number) => setValue("plateNumber", number)}
                  />
                )}
              <TextField
                fullWidth
                style={{ display: "none" }}
                id="plateNumber"
                name="plateNumber"
                label="پلاک خودرو"
                className={classes.textInput}
                inputRef={register({
                  required: false,
                  pattern: platePattern,
                  minLength: vehicleType === "MOTORCYCLE" ? 8 : 9,
                  maxLength: vehicleType === "MOTORCYCLE" ? 8 : 9,
                })}
                error={errors.plateNumber && true}
              />
              <div className={classes.errorPlate}>
                {values.plateNumber &&
                  !values.plateNumber.match(platePattern) && (
                  <p className={classes.errorText}>
                    {"فرمت فیلد پلاک خودرو صحیح نیست"}
                  </p>
                )}
              </div>
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                id="courier"
                freeSolo
                options={TPLs?.data?.length > 0 ? TPLs?.data : []}
                getOptionLabel={(option) => option.name}
                onChange={(event: any, newValue: any | null) => {
                  if (newValue) {
                    setCourier(newValue.id);
                  } else {
                    setCourier("");
                  }
                }}
                onClose={() => jumpFocusOn("driver-name")}
                renderInput={(params) => (
                  <TextField
                    inputRef={register({ required: false })}
                    name="courier"
                    {...params}
                    label="کوریر"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                id="driver-name"
                name="driverName"
                label="نام راننده"
                variant="outlined"
                inputRef={register({ required: false })}
              />
            </Grid>
            <Grid item xs={12}>
              <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                <DatePicker
                  fullWidth
                  autoOk
                  variant="inline"
                  inputVariant="outlined"
                  label={"تاریخ از"}
                  format="YYYY/MM/DD"
                  // className={classes.textInput}
                  clearable
                  okLabel="تأیید"
                  cancelLabel="لغو"
                  clearLabel="پاک کردن"
                  labelFunc={(date) =>
                    date?.isValid() ? date.format("jYYYY/jMM/jDD") : ""}
                  value={startDate}
                  name="startDate"
                  id="startDate"
                  onChange={(value) => {
                    return setStartDate(
                      value && value.toISOString(),
                      // convertPersianDigit2English(value.format('YYYY-MM-DD'))
                    );
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item xs={12}>
              <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                <DatePicker
                  fullWidth
                  autoOk
                  variant="inline"
                  inputVariant="outlined"
                  label="تاریخ تا"
                  format="YYYY/MM/DD"
                  // className={classes.textInput}
                  clearable
                  okLabel="تأیید"
                  cancelLabel="لغو"
                  clearLabel="پاک کردن"
                  labelFunc={(date) =>
                    date?.isValid() ? date.format("jYYYY/jMM/jDD") : ""}
                  value={endDate}
                  name="endDate"
                  id="endDate"
                  onChange={(value) => {
                    return setEndDate(
                      value && value.toISOString(),
                      // convertPersianDigit2English(value.format('YYYY-MM-DD'))
                    );
                  }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>
          <div className={classes.bottom}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              size="large"
            >
              اعمال فیلتر
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};
